/** @format */

import Master from '../Layouts/Master';
import { Link } from 'react-router-dom';
import ModalCustom from '../../Shared/Components/ModalCustom';
import { useLocation } from 'react-router';
import { useState, useEffect, useContext } from 'react';
import { EventContext } from '../../Contexts/EventContext';
import Pagination from '../../Shared/Components/Pagination';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';
import moment from 'jalali-moment';

const IDCard = () => {
	const eventContext = useContext(EventContext);
	const { search } = useLocation();
	const [loading, setLoading] = useState(false);
	const [removeLoading, setRemoveLoading] = useState(false);
	const [formRemoveId, setFormRemoveId] = useState();
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		getIDCards();
	}, [search]);
	const getIDCards = async () => {
		setLoading(true);
		await useApi.get(
			`/id-card${search}`,
			{},
			(res) => {
				eventContext.idCards = res.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
	};
	const removeForm = async (IDCardId) => {
		setRemoveLoading(true);

		await useApi.delete(
			`/id-card/${IDCardId}`,
			{},
			(res) => {
				success('آی دی کارت مورد نظر با موفقیت حذف شد');
				setRemoveLoading(false);
				setModalIsOpen(false);
				getIDCards();
			},
			(err) => {
				setRemoveLoading(false);
				setLoading(false);
				error('حذف به علت خطا انجام نشد');
			},
		);
	};
	return (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						لیست آی دی کارت ها
					</h1>
				</div>
				<Link
					to='/panel/id-card/create'
					className='d-flex flex-row btn btn-outline-info '>
					<i className='fad fa-plus f-16 mx-2'></i>
					<span className='f-13'>ایجاد آی دی کارت</span>
				</Link>
			</div>
			<div className='w-100 overflow-auto'>
				{eventContext.idCards?.data?.length > 0 ? (
					<table className='table table-hover'>
						<thead>
							<tr>
								<th>#</th>
								<th>عنوان</th>
								<th>عملیات</th>
							</tr>
						</thead>
						<tbody>
							{eventContext.idCards?.data?.map((item) => (
								<tr key={item.id}>
									<th>{item.id}</th>
									<td>{item.title}</td>

									<td>
										<div className='d-flex flex-row'>
											<Link
												to={`/panel/id-card/edit/${item.id}`}
												className='mx-2'>
												ویرایش
											</Link>
											<Link
												className='mx-2'
												to='#'
												onClick={(e) => {
													e.preventDefault();
													setFormRemoveId(item.id);
													setModalIsOpen(true);
												}}>
												حذف
											</Link>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div className='d-flex flex-row justify-content-center border p-3 my-3	'>
						<i className='fad fa-plus f-16 mx-2 text-secondary'></i>
						<span className='f-13 font-weight-bold text-secondary'>
							برای ایجاد آی دی کارت بر روی منوی ایجاد آی دی کارت کلیک کنید
						</span>
					</div>
				)}
			</div>

			<div className='w-100 mt-4 d-flex'>
				<Pagination
					totalPage={eventContext.idCards?.meta?.pagination?.total_pages}
					basePath={`/panel/id-card`}
				/>
			</div>
			<ModalCustom modalIsOpen={modalIsOpen}>
				<div className='d-flex flex-row border-bottom pb-2'>
					<i className='fad fa-warning f-20 mx-2'></i>
					<span className=''>آیا از حذف آی دی کارت مطمئنید‌؟</span>
				</div>
				<div className='d-flex flex-row justify-content-around my-3'>
					<button
						onClick={() => setModalIsOpen(false)}
						className='btn btn-danger w-48 f-13'>
						لغو
					</button>
					<button
						onClick={() => removeForm(formRemoveId)}
						className='btn btn-success w-48 f-13'>
						{removeLoading ? (
							<div
								className='spinner-border spinner-border-sm text-white mb-1'
								role='status'></div>
						) : (
							'بله'
						)}
					</button>
				</div>
			</ModalCustom>
		</Master>
	);
};

export default IDCard;
